import React, { useEffect, useState} from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from "remark-gfm";
import './CaseStudy.css';
import heroImage from '../assets/images/ap-hero-screens.png';

import { useNavigate } from "react-router-dom";
export default function AppleMusicRd () {
  const navigate = useNavigate();

  const [markdown, setMarkdown] = useState('');

   useEffect(() => {
    fetch('/apple-music.md')
    .then(res => res.text())
    .then(setMarkdown);
   }, []);

    return (
    <div className="case-study-content">
          <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

         {/* Hero Image Card */}
    <div className="problem-hero">
        <img src={heroImage} alt="Apple Music Redesign" />
    </div>

        {/* Title */}
        <div className="project-title">
            <h1>Apple Music Linked Shuffle</h1>
            <p className="subtitle">A UX redesign helping users link songs in a shuffled playlist for the ultimate listening experience.</p>
        </div>

        <div className="project-overview">
            <div className="overview-item">
                <strong>Role:</strong> UX Researcher, UX/UI Designer
            </div>
            <div className="overview-item">
                <strong>Tool Kit:</strong> Figma and FigJam Board
            </div>
            <div className="overview-item">
                <strong>Duration:</strong> 6 Weeks
            </div>
        </div>

        {/* Section Cards */}
        <div className="case-cards">
        {/* Example “Problem” section */}
        <div className="case-card">
            <h2>Problem</h2>
            <div className="section-body">
              <p>
              Apple Music’s shuffle experience forces users into a one‑size‑fits‑all playback model. Listeners can’t group or sequence their favorite tracks, they have to scroll through large libraries to find playlists, and they end up repeatedly skipping songs—breaking immersion and causing frustration.
              </p>
              {/* If you have a hero image: */}
            </div>
        </div>

        {/* Example “Solution” section */}
          <div className="case-card">
            <h2>Solution</h2>
            <div className="section-body">
              <p>
              The redesign adds a “link” button on each track card so users can group songs for back‑to‑back playback in shuffle mode, and it enhances playlist discovery with contextual search, personalized recommendations, and unified library controls to minimize skips and streamline navigation.
              </p>
              <ul>
                <li>Week 1 </li>
              </ul>
            </div>
          </div>


            {/* Markdown Card Content*/}
                <div className="card-content">
                    <div className="markdown-content">
                        <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                          img: ({ node, ...props}) => (
                            <img className="inner-img" alt={props.alt || ''} {...props}/>
                          )
                        }}
                        >
                          {markdown}
                      </ReactMarkdown>
                  </div>
              </div>



          {/* Analyze Card */}
          <div className="case-card">
            <div>
              <h2>Wireframes and Prototype</h2>
            </div>
          </div>
            {/* Analyze Card Content*/}
            <div className="card-content">
                <p>After testing, users reported better control over playlists...</p> 
            </div>


            {/* Design Card */}
          <div className="case-card">
            <div>
              <h2>Design and Iteration</h2>
            </div>
          </div>
                {/* Design Card Content*/}
            <div className="card-content">
                <p>After testing, users reported better control over playlists...</p>
            </div>


          {/* Video Card */}
          <div className="case-card">
            <div>
              <h2>Case Study Presentation</h2>
            </div>
          </div>
            {/* Video Card content */}
            <div className="card-content">
                <video controls className="case-video">
                    <source src="/videos/apple-music-presentation.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

        </div>

      </div>

    );
}